var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 59,
    viewBox: "0 0 79 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_9390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1801 25.6802H78.9201",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 25.6802H46.16",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 25.6802V59.1102",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.38 25.6802V59.1102",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.46 54.0002V50.7702C39.46 50.6202 39.65 50.4902 39.88 50.4902H58.68C58.91 50.4902 59.1 50.6102 59.1 50.7702V54.0002",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8901 25.6802H6.6001V49.0602H24.8901V25.6802Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 37.3701H24.8901",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5399 0.75H9.16992V19.53H40.5399V0.75Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.39 19.5298L20.13 25.6798",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.33 19.5298L29.59 25.6798",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49 43.2402V53.9902",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4599 58.2702C40.6418 58.2702 41.5999 57.3121 41.5999 56.1302C41.5999 54.9483 40.6418 53.9902 39.4599 53.9902C38.2781 53.9902 37.3199 54.9483 37.3199 56.1302C37.3199 57.3121 38.2781 58.2702 39.4599 58.2702Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.49 58.2702C50.6719 58.2702 51.63 57.3121 51.63 56.1302C51.63 54.9483 50.6719 53.9902 49.49 53.9902C48.3081 53.9902 47.35 54.9483 47.35 56.1302C47.35 57.3121 48.3081 58.2702 49.49 58.2702Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1 58.2702C60.2818 58.2702 61.24 57.3121 61.24 56.1302C61.24 54.9483 60.2818 53.9902 59.1 53.9902C57.9181 53.9902 56.96 54.9483 56.96 56.1302C56.96 57.3121 57.9181 58.2702 59.1 58.2702Z",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.18 37.06V41.35M64.18 41.35C64.18 42.39 63.3301 43.24 62.2901 43.24M64.18 41.35V11.14C64.18 10.1 63.3301 9.25 62.2901 9.25H48.05C47.01 9.25 46.16 10.1 46.16 11.14V37.06H36.69C35.65 37.06 34.8 37.91 34.8 38.95V41.35C34.8 42.39 35.65 43.24 36.69 43.24H62.2901M62.2901 43.24H46.16",
    stroke: "#2E221F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_9390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.92,
    height: 59.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomOffice);
export default __webpack_public_path__ + "static/media/roomOffice.cef114fbd6b88f36069d6f0e916920fa.svg";
export { ForwardRef as ReactComponent };